<template>
  <div class="indexPage">
    <div class="info_wrap">
      <div class="block" v-if="false">
        <div class="item flex-rowl">
          <p class="label">客户名称：</p>
          <p>测试客户</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">企业名称：</p>
          <p>测试企业</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">职务：</p>
          <p>测试职务</p>
        </div>
        <div class="item flex-between">
          <div class="left flex-rowl">
            <p class="label">联系方式：</p>
            <p>13366669999</p>
          </div>
          <div class="right">
            <i class="iconfont icon-dianhua"></i>
            <i class="iconfont icon-fuzhi"></i>
          </div>
        </div>
      </div>
      <div class="customer_wrap flex-rowl" v-if="false">
        <p>客户标签：</p>
        <div class="label_wrap flex-rowl">
          <div class="label flex-between">
            一般 <i class="iconfont icon-3tuihuanhuozhengcegouxuan"></i>
          </div>
          <div class="label flex-between">
            重要 <i class="iconfont icon-3tuihuanhuozhengcegouxuan"></i>
          </div>
          <div class="label flex-between">
            核心 <i class="iconfont icon-3tuihuanhuozhengcegouxuan"></i>
          </div>
        </div>
      </div>
      <div class="money_wrap">
        <div class="item flex-rowl">
          <p class="label">所有订单金额总计：</p>
          <p>￥ {{ orderTotalPrice | formatPrice }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">已收款总计：</p>
          <p>￥ {{ completeTotalPrice | formatPrice }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">待收款总计：</p>
          <p>￥ {{ noTotalPrice | formatPrice }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">已完成订单数量：</p>
          <p>{{ completeNum }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">未完成订单数量：</p>
          <p>{{ noNum }}</p>
        </div>
      </div>
    </div>
    <div class="screen_wrap">
      <div class="search_wrap">
        <div class="input_box flex-between">
          <van-field
            v-model="params.keyword"
            placeholder="输入关键字查找→"
            @keyup.enter="handleSearch"
          />
          <i class="iconfont icon-sousuo"></i>
        </div>
      </div>
      <div class="state_wrap flex-rowl">
        <div
          class="state flex-rowl"
          v-for="(item, index) in stateList"
          :key="index"
          @click="handleSelectState(index)"
        >
          {{ item }}
          <span class="flex-rowc"
            ><i
              class="iconfont icon-3tuihuanhuozhengcegouxuan"
              v-if="index == stateActive"
            ></i
          ></span>
        </div>
      </div>
      <div class="time_wrap">
        <div class="tit">按时间段显示：</div>
        <div class="select_wrap flex-between">
          <div class="select">
            <p>设置起始时间</p>
            <div class="box flex-between" @click="handleShow('start')">
              <van-field v-model="startTime" readonly />
              <i class="iconfont icon-yanchurili"></i>
            </div>
          </div>
          <div class="select">
            <p>设置结束时间</p>
            <div class="box flex-between" @click="handleShow('end')">
              <van-field v-model="endTime" readonly />
              <i class="iconfont icon-yanchurili"></i>
            </div>
          </div>
          <div class="btn query">查找显示</div>
          <div class="btn rest">重置</div>
        </div>
      </div>
    </div>
    <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id, item.openid)"
        >
          <div class="row_one mb">
            <p>订单编号：{{ item.orderno }}</p>
            <p>创建时间：{{ item.createdate | formatDate }}</p>
          </div>
          <div class="row_one mb">
            <p>
              {{ item.ordertypestr }}
            </p>
            <p>销售专员姓名：{{ item.saler_note }}</p>
          </div>

          <div class="row_shop_list row_one" v-if="false">
            <p>
              成本参考价：<span v-if="item.cbprice_sum"
                >¥ {{ item.cbprice_sum }}</span
              >
            </p>
            <p>
              基础零售价：<span v-if="item.price_sum"
                >¥ {{ item.price_sum }}</span
              >
            </p>
            <p>
              批发参考价：<span v-if="item.pfprice_sum"
                >¥ {{ item.pfprice_sum }}</span
              >
            </p>
            <p>
              基础批发价：<span v-if="item.groupprice_sum"
                >¥ {{ item.groupprice_sum }}</span
              >
            </p>
          </div>

          <div class="row_four">
            <div class="txt flex-between">
              <p>订单价格核算：</p>
              <p v-if="item.price_original">
                <span>￥</span>{{ item.price_original | formatPrice }}
              </p>
            </div>
            <div class="txt2 flex-between">
              <p>物流费用：</p>
              <p v-if="item.logisticsdf == 1">到付</p>
              <p v-else>￥{{ item.runfee ? item.runfee : 0 }}</p>
            </div>
          </div>
          <div class="row_four">
            <div class="txt flex-between">
              <p>实际订单价格：</p>
              <p><span>￥</span>{{ item.price | formatPrice }}</p>
            </div>
            <!-- <div class="txt1 flex-between">
            <p>差额：</p>
            <p><span>￥</span>{{ item.runfee }}</p>
          </div> -->
            <div class="txt flex-between">
              <p>已付金额：</p>
              <p v-if="item.paynum">￥{{ item.paynum | formatPrice }}</p>
              <p v-else>￥ 0.00</p>
            </div>
            <div class="txt2 flex-between">
              <p>差额：</p>
              <p>￥{{ item.diffrentprice | formatPrice }}</p>
            </div>
            <div class="txt2 flex-between">
              <p>待结清金额：</p>
              <p>￥{{ item.waitMoney | formatPrice }}</p>
            </div>
          </div>
          <div class="order_status mb">
            <div class="txt flex-between">
              <p>订单审核状态：</p>
              <!-- 	 	  -->

              <p class="red">
                {{
                  item.ischeck == 0
                    ? "待审核"
                    : item.ischeck == 1
                    ? "审核通过"
                    : item.ischeck == 2
                    ? "审核不通过"
                    : ""
                }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>退费申请状态：</p>
              <p class="red">
                {{
                  item.isreturn === true
                    ? "是"
                    : item.isreturn === false
                    ? "否"
                    : "无"
                }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>退费状态：</p>
              <p class="red">
                {{ item.returnstate ? item.returnstate : "无" }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>订单情况：</p>
              <p class="red">
                {{
                  item.ordertalk == 1
                    ? "进行中"
                    : item.ordertalk == 2
                    ? "已完成"
                    : item.ordertalk == 3
                    ? "已关闭"
                    : "无"
                }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>发货情况：</p>
              <p class="red">{{ item.orderstate }}</p>
            </div>
          </div>
          <div class="row_one">
            <p>
              客户名称：<span>{{ item.qy_truename }}</span>
            </p>
            <p>
              客户企业：<span>{{ item.qw_appidstr }}</span>
            </p>
            <p>
              客户职务：<span>{{ item.qw_job }}</span>
            </p>
            <p>
              联系方式：<span>{{ item.qy_linktype }}</span>
            </p>
          </div>
        </div>
      </template>
      <van-empty description="暂无数据" v-else-if="dataList.length == 0 && !loading" />
    </div>
    <!-- 底部操作 -->
    <div class="bottom-operation flex-rowc">
      <div class="arr" @click="handleReturn">
        <i class="iconfont icon-bottom"></i>
      </div>
      <div class="item flex-rowc" @click="handleGo">
        <div class="custom_btn">新建订单</div>
      </div>
    </div>

    <!-- 日历 start -->
    <van-calendar v-model="show" :min-date="minDate" @confirm="onConfirm" />
    <!-- 日历 end -->
  </div>
</template>
<script>
import { encryptstringadd, encryptstringview } from "../../../api/api";
import { getOrderList } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "rServiceRecordList",
  data() {
    return {
      stateList: [
        "全部",
        "待审核",
        "审核通过",
        "审核不通过",
        "支付未完成",
        "已支付完成",
        "退费申请待审核",
        "退费申请不通过",
        "退款中",
        "已退款",
      ],
      stateActive: 0,
      keyword: "",

      show: false,
      minDate: new Date(),
      timeType: "",
      startTime: "",
      endTime: "",

      dataList: [],
       loading: false, // 是否正在加载中
      startDataValue: "",
      endDataValue: "",
      params: {
        // openid: "o6LS_63aFOa1Ec2p1p0wUpQ6NHCA",
        openid: this.$store.state.OPENID,
        qyid: this.$store.state.USERINFO.qy
          ? this.$store.state.USERINFO.qy.id
          : 0,
        ordertype: 43, // 订单类型 43=销售业务订单
        returntalk: "", // 退款状态 =1=退款中 2=已退款
        ischeck: "", // 订单审核 =0=待审核 1=审核通过 2=审核不通过
        paystate: "", // 支付状态 =0=未支付 1=已支付
        orderstate: "", // 订单状态 =未支付 待发货 已发货 已完成 已申请退费 已退费
        keyword: "",
      },
      orderTotalPrice: 0, // 订单总金额
      completeTotalPrice: 0, // 已收款总计
      noTotalPrice: 0, // 待收款总计
      completeNum: 0, // 已完成订单数量
      noNum: 0, //未完成订单数量
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getOrderList();
      } else {
        this.$router.back();
      }
    },
    // 获取商品订单
    getOrderList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
       this.loading = true;
      getOrderList(this.params).then((res) => {
        res.forEach((v) => {
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
          }
          // 支付状态orderstate 未支付
          if (v.orderstate == "未支付") {
            this.noTotalPrice = calculator(this.noTotalPrice)
              .add(v.price)
              .toNumber();
          } else {
            this.completeTotalPrice = calculator(this.completeTotalPrice)
              .add(v.price)
              .toNumber();
          }
          // 订单状态
          // ordertalk 2-已完成
          if (v.ordertalk == 2) {
            this.completeNum = calculator(this.completeNum)
              .add(v.totalNum)
              .toNumber();
          } else {
            this.noNum = calculator(this.noNum).add(v.totalNum).toNumber();
          }
          this.orderTotalPrice = calculator(this.orderTotalPrice)
            .add(v.price)
            .toNumber();
            // 待结清金额 = price - paynum
          v.waitMoney = calculator(v.price)
            .subtract(v.paynum ? v.paynum : 0)
            .toNumber()
        });
        this.dataList = res;
        Toast.clear();
        this.loading = false;
      });
    },
    handleSearch() {
      this.orderTotalPrice = 0;
      this.completeTotalPrice = 0;
      this.noTotalPrice = 0;
      this.completeNum = 0;
      this.noNum = 0;
      this.getOrderList();
    },

    handleSelectState(index) {
      this.stateActive = index;
    },
    handleShow(type) {
      let { startTime } = this;
      if (startTime == "" && type == "end") {
        this.$toast("请选择开始时间");
        return;
      } else if (startTime != "" && type == "end") {
        let newDate = new Date(startTime);
        newDate.setDate(newDate.getDate() + 1);
        this.minDate = newDate;
      }
      this.timeType = type;
      this.show = true;
    },
    onConfirm(e) {
      let { timeType } = this;
      this.show = false;
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      if (timeType == "start") {
        this.startTime = year + "-" + month + "-" + date;
      } else if (timeType == "end") {
        this.endTime = year + "-" + month + "-" + date;
      }
    },
    handleReturn() {
      this.$router.back();
    },
    handleGo() {
      // this.$router.push(`/resourceIndex/rServiceAddOrder/${this.id}`);
      this.encryptstringadd("rServiceAddOrder", { id: this.id });
    },

    handleDetail(id, openid) {
      this.encryptstringadd("cOrderDetail", { id, openid, type: 1 });
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding-bottom: 280px;
  /deep/ .van-cell {
    padding: 0;
    background: none;
  }
  .info_wrap {
    font-size: 22px;
    color: #3c3c3c;
    padding: 100px 89px 0;
    .item {
      margin-bottom: 18px;
      .right {
        .iconfont {
          font-size: 32px;
          margin-left: 40px;
        }
      }
    }
    .block {
      .label {
        width: 160px;
        flex-shrink: 0;
      }
    }
    .customer_wrap {
      margin: 45px 0 60px;
      p {
        margin-right: 30px;
      }
      .label_wrap {
        .label {
          height: 40px;
          line-height: 40px;
          border: 1px solid #d2d2d2;
          padding: 0 10px 0 20px;
          box-sizing: border-box;
          margin-right: 15px;
          .iconfont {
            font-size: 38px;
            margin-left: 10px;
          }
        }
      }
    }
    .money_wrap {
      .label {
        width: 220px;
        flex-shrink: 0;
      }
    }
  }
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    width: 610px;
    margin: 70px auto 50px;
    .search_wrap {
    }
    .state_wrap {
      flex-flow: wrap;
      margin: 70px 0 39px;
      .state {
        border: 1px solid #d2d2d2;
        height: 40px;
        line-height: 40px;
        padding: 0 10px 0 19px;
        margin: 0 10px 20px 0;
        span {
          width: 20px;
          flex-shrink: 0;
          margin-left: 25px;
        }
        .iconfont {
          font-size: 36px;
        }
      }
    }
    .time_wrap {
      .tit {
        font-size: 22px;
        color: #3c3c3c;
        margin-bottom: 13px;
      }
      .select_wrap {
        align-items: flex-end;
        .select {
          p {
            margin-bottom: 8px;
          }
          .box {
            width: 190px;
            height: 40px;
            font-size: 20px;
            padding: 0 10px;
            box-sizing: border-box;
            border: 1px solid #d2d2d2;
          }
        }
        .btn {
          height: 40px;
          line-height: 40px;
          background: #1e1e1e;
          font-size: 18px;
          color: #fff;
          text-align: center;
          &.query {
            width: 120px;
          }
          &.rest {
            width: 85px;
          }
        }
      }
    }
  }
  .order_wrap {
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;

        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 30px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            // &:last-child {
            //   font-size: 30px;
            // }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        .red {
          color: #ee0032;
        }
      }
      .mb {
        margin-bottom: 30px;
      }
    }
  }
  .bottom-operation {
    .arr {
      position: absolute;
      left: 45px;
    }
    .custom_btn {
      width: 390px;
      height: 70px;
      line-height: 70px;
    }
  }
}
</style>